import { render, staticRenderFns } from "./BaseScopedList.vue?vue&type=template&id=6b36ac3a&scoped=true"
import script from "./BaseScopedList.vue?vue&type=script&lang=js"
export * from "./BaseScopedList.vue?vue&type=script&lang=js"
import style0 from "./BaseScopedList.vue?vue&type=style&index=0&id=6b36ac3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36ac3a",
  null
  
)

export default component.exports